module.exports = __webpack_public_path__ + "img/Schedule-bro.d041102b.png";